import { render, staticRenderFns } from "./companyDataDetail.vue?vue&type=template&id=f30ec52c&scoped=true"
import script from "./companyDataDetail.vue?vue&type=script&lang=js"
export * from "./companyDataDetail.vue?vue&type=script&lang=js"
import style0 from "./companyDataDetail.vue?vue&type=style&index=0&id=f30ec52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30ec52c",
  null
  
)

export default component.exports